/*
 * @Author: wangshengqiang
 * @Date: 2021-05-07 14:53:48
 * @LastEditTime: 2021-05-07 15:30:15
 * @LastEditors: wangshengqiang
 * @Description: 字典数据
 */
import qs from 'qs';
import request from '@/utils/request';
import { getQueryParam } from '@/utils/tool'; // 查询证件列表数据

export const queryAttrs = data => {
  return request('/order/channel/front/queryAttrs', {
    method: 'POST',
    data
  });
}; // 获取数据字典列表 查询入参 country：国籍 city：省市 district：省市区 bank：银行： occupation：职业

export const getEnumList = (dictType, _goodsId) => {
  const {
    goodsId
  } = getQueryParam();
  return request('/v1/common/queryDictList', {
    method: 'POST',
    data: {
      goodsId: _goodsId || goodsId,
      dictType
    }
  });
}; // 根据银行账号查询开户银行

export const queryBankBinInfo = params => {
  return request(`/v1/common/queryBankBinInfo?${qs.stringify(params)}`, {
    method: 'GET'
  });
};